import React from 'react';
import styles from '../../pages/product.module.css';

const formatDate = (date) =>
  date
    ? new Date(date).toLocaleDateString('en-UK', {
        dateStyle: 'medium',
      })
    : '-';

const formatPrice = (priceInCents, currency) =>
  typeof priceInCents === 'number'
    ? new Intl.NumberFormat('en-UK', {
        style: 'currency',
        currency: currency || 'EUR',
      }).format(priceInCents / 100)
    : '-';

const SubscriptionCard = ({ subscription, remainingRfqQuota }) => {
  const plan = subscription?.Plan;

  return (
    <div className='product-block col-md-6'>
      <h4 className='h4'>Quantila Subscription</h4>
      {subscription && plan ? (
        <>
          <p className='product-subheads product-type mb-2 mt-3'>
            <span className={styles.label}>Plan:</span>
            <span className={styles.value}>{plan.name}</span>
          </p>
          <p className='product-subheads product-type mb-2'>
            <span className={styles.label}>Status:</span>
            <span className={styles.value}>{subscription.status}</span>
          </p>
          <p className='product-subheads product-type mb-2'>
            <span className={styles.label}>Price:</span>
            <span className={styles.value}>
              {formatPrice(plan.price, plan.currency)}
            </span>
          </p>
          <p className='product-subheads product-type mb-2'>
            <span className={styles.label}>RFQs remaining:</span>
            <span className={styles.value}>
              {remainingRfqQuota ?? 0} / {plan.maxRfqPerMonth}
            </span>
          </p>
          <p className='product-subheads product-type mb-2'>
            <span className={styles.label}>Current period:</span>
            <span className={styles.value}>
              {formatDate(subscription.currentPeriodStart)} -{' '}
              {formatDate(subscription.currentPeriodEnd)}
            </span>
          </p>
        </>
      ) : (
        <p className='text-muted mt-3'>No active Quantila subscription.</p>
      )}
    </div>
  );
};

export default SubscriptionCard;
